import $ from '../core/Dom';
import Viewport from '../core/Viewport';
import Dispatch from '../core/Dispatch';

import verge from 'verge';

import * as eventKeys from '../lib/events';

export default el => {

    const $el = $(el);
    let isVisible;

    const dispatchPanelHeight = () => {
        const style = getComputedStyle($el.get(0));
        const panelHeight = $el.height() + parseInt(style.marginBottom, 10);
        Dispatch.emit(eventKeys.INFORMATION_PANEL_UPDATE, { height: panelHeight });
    };
    
    const activatePanel = () => {
        Dispatch.emit(eventKeys.INFORMATION_PANEL_ACTIVATED);
        Dispatch.emit(eventKeys.LOCK_MENU_BAR);

        const startScrollTop = verge.scrollY();

        $el.css({ display: 'block', height: 'auto' });
        const scrollPos = verge.scrollY();

        const style = getComputedStyle($el.get(0));
        const totalHeight = $el.height() + parseInt(style.marginBottom, 10);
        
        if (startScrollTop === 0) {
            window.scroll(0, scrollPos + totalHeight);
        } else {
            window.scroll(0, startScrollTop);
        }
        
        dispatchPanelHeight();
        
        setTimeout(() => {
            Dispatch.emit(eventKeys.UNLOCK_MENU_BAR);
        }, 100);
    };
    
    const onResize = e => {
        e.preventDefault();
        dispatchPanelHeight();
    };
    
    const onBreakpoint = e => {
        e.preventDefault();
    };

    const onScroll = () => {
        const shouldBeVisible = Viewport.visible(el);
        if (shouldBeVisible === isVisible) {
            return;
        }
        if (shouldBeVisible) {
            // Info panel was just made visible
            Dispatch.emit(eventKeys.INFORMATION_PANEL_VISIBLE);
        } else {
            // Info panel was just made invisible
            Dispatch.emit(eventKeys.INFORMATION_PANEL_HIDDEN);
        }
        if (shouldBeVisible !== isVisible) {
            if (shouldBeVisible) {
                $('body').addClass('-infopanel');
            } else {
                $('body').removeClass('-infopanel');
            }
        }
        isVisible = shouldBeVisible;
    };
    
    const init = () => {
        setTimeout(() => {
            activatePanel();
            onScroll();
        }, 50);
        
        Viewport.on('breakpoint', onBreakpoint);
        Viewport.on('resize', onResize);

        Viewport.on('scroll', onScroll);

    };

    const destroy = () => {

        Viewport.off('breakpoint', onBreakpoint);
        Viewport.off('resize', onResize);

        Viewport.off('scroll', onScroll);
    };

    return {
        init,
        destroy
    };
};
